import React, { useState, useEffect } from "react";

import SharedContactScreen from "@/shared/pages/ContactScreen";
import sassVariables from "@/shared/styles/variables.module.scss";
import useMediaQuery, { MEDIA_QUERIES } from "@/shared/hooks/useMediaQuery";
import Loader from "@/shared/components/Loader/Loader";
import useIsDOMHydratedAfterSSR from "@/hooks/useIsDOMHydratedAfterSSR";

const ContactScreen = () => {
  const [width, setWidth] = useState(sassVariables.desktopWidth);
  const isHydrated = useIsDOMHydratedAfterSSR();
  const isMobile = useMediaQuery(MEDIA_QUERIES.untilTablet);
  const isTablet = useMediaQuery(MEDIA_QUERIES.untilDesktopAndDesktop);
  const isMobileOrTablet = isMobile || isTablet;

  useEffect(() => {
    setWidth(isMobileOrTablet ? window.width : sassVariables.desktopWidth);
  }, [isMobileOrTablet]);

  return (
    <SharedContactScreen
      width={width}
      isMobile={isMobile && isHydrated}
      isTablet={isTablet && isHydrated}
      loaderProps={{ isPositionAbsolute: true }}
      isStaticWidth
    />
  );
};

export default ContactScreen;
